
/* --------------------------------------------------------------------------
   Fäll ihop och fäll ut

   Varje kort i flikarna kan fällas ihop till sin rubrik. Den som bara bryr
   sig om några av korten får en kort sida. Sidomenyn fälls ihop med samma
   lagring (ui/sidebar.js).

   Knappen står före rubriken och heter det rubriken heter (aria-labelledby),
   så att en skärmläsare säger "Försäljning per dag, knapp, utfälld". Ett klick
   på själva rubriken gör samma sak. Rubriker som skrivs om från JavaScript
   (utvecklingens, kundprofilens) behåller knappen, eftersom den ligger
   utanför h3.

   Vad som är hopfällt sparas i webbläsaren (localStorage), bara kortens
   namn — aldrig något ur kvittoexporten. Går det inte att spara, som i privat
   läge, fungerar knapparna ändå; valet glöms bara när sidan stängs.

   Inget animeras: korten fälls ihop och ut ofta, och en animation skulle
   bara göra det långsammare.
   -------------------------------------------------------------------------- */

const KEY = 'ec-hopfallda';
const CHEVRON = '<svg class="chev" aria-hidden="true" focusable="false" viewBox="0 0 16 16"><path d="M4 6l4 4 4-4"/></svg>';

function load(){
  try{
    const v = JSON.parse(localStorage.getItem(KEY) || '[]');
    return new Set(Array.isArray(v) ? v.filter(x => typeof x === 'string') : []);
  }catch{
    return new Set();
  }
}
function save(set){
  try{ localStorage.setItem(KEY, JSON.stringify([...set])); }
  catch{ /* privat läge eller avstängd lagring: valet gäller tills sidan stängs */ }
}

const closed = load();

/** Ett stabilt namn för kortet: dess id, annars rubrikens text när sidan laddades. */
const slug = t => t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
  .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

function setOpen(card, open, remember = true){
  card.classList.toggle('is-collapsed', !open);
  card.querySelector(':scope > .card-head .card-toggle').setAttribute('aria-expanded', String(open));
  if(remember){
    if(open) closed.delete(card.dataset.fold); else closed.add(card.dataset.fold);
    save(closed);
  }
}
const toggle = card => setOpen(card, card.classList.contains('is-collapsed'));

/** Det sparade valet för en del av sidan, till exempel sidomenyn. */
export const remembered = key => closed.has(key);
export function remember(key, isClosed){
  if(isClosed) closed.add(key); else closed.delete(key);
  save(closed);
}

export function initCollapse(){
  let n = 0;
  for(const card of document.querySelectorAll('.panel .card')){
    const h3 = card.querySelector(':scope > .card-head h3');
    if(!h3) continue;
    if(!h3.id) h3.id = 'kortrubrik-' + (++n);
    card.dataset.fold = card.id || slug(h3.textContent);
    const title = h3.parentElement;
    title.classList.add('card-title');
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'card-toggle';
    btn.setAttribute('aria-labelledby', h3.id);
    btn.setAttribute('aria-expanded', 'true');
    btn.innerHTML = CHEVRON;
    title.prepend(btn);
    btn.addEventListener('click', () => toggle(card));
    // Rubriken är också klickbar, utom hjälpknappen i den
    h3.addEventListener('click', e => { if(!e.target.closest('button, a')) toggle(card); });
    if(closed.has(card.dataset.fold)) setOpen(card, false, false);
  }

}
